// extracted by mini-css-extract-plugin
module.exports = {"rssStyle":"RssDirective_rssStyle__OGVMQ","muted":"RssDirective_muted__-rH2z"};